/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal
 */

var demoTeam = {
    created_user_id:'73799',
    name:'trace_devel',
    title:'Trace Devel 2',
    abbr:'TD2',
    players_gender:null,
    players_birth_year:'2004',
    creation_time:'2017-04-27 18:03:42',
    teamsnap_team_id:'2882801',
    teamsnap_update_time:'2017-07-17 13:39:30',
    access_password:'spicyfood36',
    club_id:'2',
    team_id:1
}

var demoGame = {
    game_id: 123,
    date: '2018-02-18',
    created_user_id: '-1',
    home_team: {
        team_id: 9,
        title: 'Ron\'s Test Team',
        name: 'ASDFGH',
        players: [],
        s3_sources: 'https://s3.amazonaws.com/soccer-app-data.traceup.com/data/ron_test_team-170831-19',
        abbr: 'RTT'
    },
    away_team: {
        team_id: null,
        title: null,
        name: null,
        players: [],
        s3_sources: null,
        abbr: null
    },
    field: {
        field_name: null,
        title: null,
        name: null,
        aspect: null
    },
    creation_time: '2018-02-18 16:34:00',
    first_half_start_time: null,
    first_half_end_time: null,
    second_half_start_time: null,
    second_half_end_time: null,
    flip_field: '1',
    season: null,
    error_message: '',
    status: 'unprocessed',
    is_status_processing: false,
    linked_game_id: null,
    trace_case_id: '1234',
    pi_id: '',
    game_time: '2018-02-18 16:34:00',
    half_length: 45,
    home_team_score: 0,
    away_team_score: 0,
    home_jersey_color: '#ff0000',
    away_jersey_color: '#0000ff',
}

export default class MockService {
    constructor() {
        this._loggedIn = false
        this.team = null
        this.game = null
        this.games = []
    }

    get loggedIn() {
        return this._loggedIn
    }

    set loggedIn(val) {
        this._loggedIn = val
        if (val) {
            this.team = demoTeam
            this.game = demoGame
        } else {
            this.team = null
            this.game = null
        }
    }

    do(url) {
        var resp = this._getResponse(url)
        if (resp) {
            console.log('MOCKING:', url)
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    if (this.loggedIn) {
                        this._logicRequest(url)
                        console.log('MOCKED:', url, resp)
                        resolve(resp.data)
                    } else {
                        var error = {
                            success: false,
                            error: { id: 'team_not_logged_in' }
                        }
                        console.log('MOCKED:', url, error)
                        resolve(error)
                    }
                }, 500)
            })
        } else {
            return null
        }
    }

    _logicRequest(url) {
        switch (url) {
        case 'GET:/webapp/teams/self/games':
            break
        case 'POST:/webapp/teams/create':
            break
        case 'GET:/webapp/games/123':
            break
        case 'POST:/webapp/games/123':
            break
        case 'POST:/webapp/games/create':
            break
        case 'GET:/webapp/games/123/archives-info':
            break
        case 'POST:/webapp/games/123/process':
            break
        default:
            break
        }
    }

    _getResponse(url) {
        return null
    }
}
